import { Spin, Tabs, Tag, Tooltip } from "antd";
import { isNullOrUndefined } from "src/common/utils";
import { AccessVisibility } from "src/components/AccessVisibility";
import BackTextComponent from "../../../components/BackTextComponent";
import { UserGroupDetailsController } from "./controller";
import "./index.scss";
import MembershipConditions from "./membershipConditions";
import { userGroupDetailsTabTypes } from "./model";
import UserGroupInfo from "./userGroupInfo/index.js";

const { TabPane } = Tabs;

function UserGroupDetails({ userGroupUniqueName, userGroupTypeUniqueName }) {
  const {
    loading,
    errorFetchingDetails,
    userGroupRepresentationName,
    titleName,
    userGroupInfoTabProps,
    userGroupMembersTabProps,
    activeTab,
    userGroupTypeName,
    backToUserGroupList,
    handleNavigate,
    backToTabList,
    usergroupMembershipConditionProps,
    isPublished,
    userGroupIdentifier,
    userGroupTypeSingularFullName,
  } = UserGroupDetailsController(userGroupUniqueName, userGroupTypeUniqueName);

  return (
    <div className="user-groups-container">
      {errorFetchingDetails ? (
        <div className="error-text">Error Fetching Details</div>
      ) : (
        <Spin spinning={loading}>
          <BackTextComponent
            backText={`${backToTabList} ${userGroupTypeName}`}
            clickFunctionality={backToUserGroupList}
          />
          <div className="user-groups-title">
            {titleName}
            <span className="status-container">
              {isNullOrUndefined(isPublished) ? null : isPublished ? (
                <Tag className={"status-tag"} color="success">
                  Published
                </Tag>
              ) : (
                <Tag className={"status-tag"} color="default">
                  Draft
                </Tag>
              )}
            </span>
          </div>
          <div className="user-groups-tabs">
            <Tabs
              type="card"
              onChange={handleNavigate}
              activeKey={activeTab}
              defaultActiveKey={userGroupDetailsTabTypes.Members}
            >
              <TabPane
                tab={`${userGroupRepresentationName} ${userGroupDetailsTabTypes.Info}`}
                key={userGroupDetailsTabTypes.Info}
              >
                <UserGroupInfo {...userGroupInfoTabProps} />
              </TabPane>
              <TabPane
                tab={`${userGroupDetailsTabTypes.Members}`}
                key={userGroupDetailsTabTypes.Members}
              >
                <UserGroupInfo {...(userGroupMembersTabProps as any)} />
              </TabPane>
              {usergroupMembershipConditionProps.haveMembershipConditionsViewAccess === true ? (
                <TabPane
                  tab={`${userGroupDetailsTabTypes.MembershipConditions}`}
                  key={userGroupDetailsTabTypes.MembershipConditions}
                >
                  <MembershipConditions {...usergroupMembershipConditionProps} />
                </TabPane>
              ) : null}
              <TabPane
                tab={
                  <Tooltip
                    title={
                      isPublished
                        ? ""
                        : `Access visibility is not applicable for ${userGroupTypeSingularFullName} in draft state`
                    }
                  >
                    <span>{userGroupDetailsTabTypes.AccessVisibility}</span>
                  </Tooltip>
                }
                key={userGroupDetailsTabTypes.AccessVisibility}
                disabled={!isPublished}
              >
                {!isNullOrUndefined(userGroupIdentifier?.id) ? (
                  <AccessVisibility
                    userEmail={null}
                    toShowFor={{ user: false, userGroup: true }}
                    userGroup={userGroupIdentifier}
                    reduceTableHeight="480px"
                  />
                ) : null}
              </TabPane>
            </Tabs>
          </div>
        </Spin>
      )}
    </div>
  );
}

export default UserGroupDetails;
